
import { GameResultHeader } from "./components/GameResultHeader";
import { GameResultContent } from "./components/GameResultContent";
import { VetoDialog } from "../result/VetoDialog";
import { ReasoningModal } from "../result/ReasoningModal";
import { useGameResultState } from "@/hooks/useGameResultState";
import { openSocialMedia } from "@/utils/socialMediaUtils";
import type { GameResult } from "@/hooks/useGameFlow";
import type { DailyPuzzle } from "@/lib/types/game";
import type { LogicRule } from "@/lib/game-utils";

interface GameResultScreenProps {
  gameResult: GameResult;
  puzzle: DailyPuzzle;
  filteredRules?: LogicRule[];
  isUsingExternalData?: boolean;
  onGoBack?: () => void;
}

export function GameResultScreen({
  gameResult,
  puzzle,
  filteredRules,
  isUsingExternalData = false
}: GameResultScreenProps) {
  const {
    vetoDialogOpen,
    setVetoDialogOpen,
    reasoningModalOpen,
    setReasoningModalOpen,
    currentResult
  } = useGameResultState(gameResult, puzzle);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-4 flex flex-col items-center">
        <GameResultHeader />
        
        <GameResultContent
          currentResult={currentResult}
          puzzle={puzzle}
          onVetoClick={() => setVetoDialogOpen(true)}
          onReasoningClick={() => setReasoningModalOpen(true)}
          isUsingExternalData={isUsingExternalData}
        />
      </div>
      
      <ReasoningModal 
        open={reasoningModalOpen}
        onOpenChange={setReasoningModalOpen}
        rule={puzzle.correctRule}
        words={puzzle.correctOrder}
      />
      
      <VetoDialog 
        open={vetoDialogOpen}
        onOpenChange={setVetoDialogOpen}
        onSocialMediaClick={openSocialMedia}
      />
    </div>
  );
}
